import React from "react";
import "assets/components/howItWorks.scss";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import { Grid, Typography } from "@mui/material";

const HowItWorks = (props) => {
  return (
    <>
      <div className="container-section-3">
        <div className="col-8 col-sm-12 col-lg-8 box2-section-3">
          <h2 className="title-sectionTwo-denuncia text-light">
            Come funziona
          </h2>
          <Typography className="subtitle-sectionTwo-denuncia text-light">
            Tre semplici passaggi per presentare la tua denuncia online
          </Typography>
          <div className="bubbles-container">
            <div className="d-flex">
              <div
                className="bubble bubble-text first-bubble"
                style={{ width: "80px" }}
              >
                {/* 01 */}
                <span className="number-only">1</span>
              </div>
              <div className="mt-2 box-text">
                <p className="text-title-bubble p-0 m-0">Registrati</p>
                <p className="subtitle-title-bubble">
                  Crea il tuo account in meno di un minuto, o effettua il login
                  se sei già registrato.
                </p>
              </div>
            </div>
            <div className="d-flex">
              <div
                className="bubble bubble-text second-bubble"
                style={{ width: "80px" }}
              >
                {/* 02 */}2
              </div>
              <div className="box-text" style={{ marginTop: "-13px" }}>
                <p className="text-title-bubble p-0 m-0">Compila la denuncia</p>
                <p className="subtitle-title-bubble">
                  Scegli il tipo di denuncia da presentare e compila pochi
                  semplici campi guidati. Il documento sarà generato in tempo
                  reale.
                </p>
              </div>
            </div>
            <div className="d-flex">
              <div
                className="bubble bubble-text last-bubble three-bubble"
                style={{ width: "80px" }}
              >
                {/* 03 */}3
              </div>
              <div className="box-text" style={{ marginTop: "0px" }}>
                <p className="text-title-bubble p-0 m-0">Ottieni la ricevuta</p>
                <p className="subtitle-title-bubble">
                  Scarica la denuncia e firmala digitalmente con il nostro
                  processo integrato. Otterrai la ricevuta di invio e non dovrai
                  fare altro: il deposito è concluso!
                </p>
              </div>
            </div>
            <Grid container className="col-12 pb-5 box-button">
              <Grid item xs={2} sm={1.4} />
              <Grid
                item
                xs={10}
                sm={5}
                className="link-faq-margin"
                style={{ display: "flex", alignItems: "center" }}
              >
                <a href="#Faq" className="linkFaq">
                  Leggi le FAQ
                </a>
              </Grid>
              <Grid item xs={10} sm={5}>
                <a
                  href="/register"
                  style={{
                    backgroundColor: "#58979d",
                    color: "#fff",
                  }}
                  className="btn button-section-3 box-button-inizia"
                >
                  Inizia subito
                </a>
              </Grid>
            </Grid>
          </div>
        </div>
        <div className="img-section-3-denuncia"></div>
      </div>
    </>
  );
};

export default HowItWorks;
